import { Response } from '@marketplace-web/core-api/api-client-util'

import { GetNearbyPickupPointsArgs, NearbyPickupPointsResp } from '../types/nearby-pickup-points'
import { transformPickupPointsDto } from './pickup-point'
import { transformShippingOptionDtos } from './shipping-option'

export const getNearbyPickupPointsArgsToParams = ({
  countryCode,
  latitude,
  longitude,
}: GetNearbyPickupPointsArgs) => ({
  country_code: countryCode,
  latitude,
  longitude,
})

export const transformNearbyPickupPoints = (response: Response<NearbyPickupPointsResp>) => {
  return {
    nearbyShippingPoints: transformPickupPointsDto(response.nearby_shipping_points),
    nearbyShippingOptions: transformShippingOptionDtos(response.nearby_shipping_options),
    suggestedShippingPointCode: response.suggested_shipping_point_code,
  }
}
